import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randSequence } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randSequence>[0], undefined>;
type CharType = Exclude<Options["charType"], undefined> | "";

const charTypes: Record<CharType, string> = {
  "": "",
  numeric: "numeric",
  alpha: "alpha",
  alphaNumeric: "alphaNumeric",
  special: "special",
};

export const randSequenceNodeDef = createNodeDef({
  type: "randSequence",
  displayName: "Sequence",
  defaultName: "sequence",
  fields: [
    { type: DataFieldType.NUMBER, key: "size", label: "Size" },
    { type: DataFieldType.TEXT, key: "chars", label: "Chars" },
    {
      type: DataFieldType.SELECT,
      key: "charType",
      label: "Char Type",
      options: charTypes,
    },
  ],
  initialData: (): { size?: number; chars: string; charType: CharType } => ({
    size: undefined,
    chars: "",
    charType: "",
  }),
  generate: ({ node }) => {
    const size = node.data.size || undefined;
    const chars = node.data.chars || undefined;
    const charType = node.data.charType || undefined;

    return chars
      ? randSequence({ size, chars })
      : randSequence({ size, charType });
  },
});
